import React from "react";

export const truncateToPrecision = (number, precision = 3) => {
  const epsilon = 1e-10;
  const factor = Math.pow(10, precision);
  return (Math.trunc(number * factor + epsilon) / factor).toFixed(precision);
};

export const needsPopup = (product) =>
  !!((product?.alternateUom?.length > 0 && product?.showAlternateUomInPos === "Y") || product?.isManualQty === true || product?.showWeightPopup === "Y");

// BUG-2451: a non-decimal UOM (Numbers/Pieces) is sold in whole quantities only. A product
// with no uomData is left unrestricted -- its UOM is unknown, not non-decimal.
export const isFractionBlocked = (product) => {
  const uom = product?.uomData?.[0];
  return !!uom && uom.decimal !== "Y";
};

export const getSelectedUomIsDecimal = (product, selectedUomId) => {
  if (!selectedUomId) return product?.uomData?.[0]?.decimal === "Y";
  if (selectedUomId === product?.csUomId) return product?.uomData?.[0]?.decimal === "Y";
  const altUom = product?.alternateUom?.find((u) => u.csUomId === selectedUomId);
  if (altUom) return altUom.decimal === "Y";
  return product?.uomData?.[0]?.decimal === "Y";
};

export const getUomPrice = (product, selectedUomId) => {
  const basePrice = product?.sunitprice || 0;
  if (!selectedUomId || selectedUomId === product?.csUomId) return basePrice;
  if (Array.isArray(product?.priceList) && product.priceList.length > 0) {
    const matchedPrice = product.priceList.find((p) => p.uomId === selectedUomId);
    if (matchedPrice) return matchedPrice.pricestd || matchedPrice.pricelist || basePrice;
  }
  const altUom = product?.alternateUom?.find((u) => u.csUomId === selectedUomId);
  if (altUom && altUom.convertionRate) return basePrice * Number(altUom.convertionRate);
  return basePrice;
};

export const getUomIcon = (uomName) => {
  const name = uomName?.toLowerCase() || "";
  if (name.includes("piece") || name.includes("pcs") || name.includes("nos") || name.includes("unit")) {
    return (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
        <line x1="12" y1="22.08" x2="12" y2="12" />
      </svg>
    );
  }
  return (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M12 3v18" />
      <path d="M8 6l4-3 4 3" />
      <rect x="4" y="10" width="16" height="10" rx="1" />
      <path d="M8 15h8" />
      <path d="M8 18h8" />
    </svg>
  );
};
